import { EventsService } from "@mojility/core-es6";

export default {
  name: 'eventsService',
  fn: EventsService
};